import pluralize from '../../utils/pluralize';
import type { MobileContentFrameWindow } from './types';

declare let window: MobileContentFrameWindow;

const remove = () => {
  const container = document.querySelector('.failed-highlights-message-container');
  if (!container) {
    return;
  }
  container.replaceChildren();
};

const add = ({ amount, text }: { amount: number; text?: string; }) => {
  const container = document.querySelector('.failed-highlights-message-container');
  if (!container) {
    return;
  }

  const amountString = amount === 1 ? 'a' : amount;
  const pronoun = amount === 1 ? 'it' : 'them';
  const defaultText = `You made ${amountString} ${pluralize('highlight', amount)} on the original page that we aren&apos;t able to overlay here.`;
  container.innerHTML = `<p class="failed-highlights-message">
    ${text || defaultText}
    <button>View ${pronoun}</button>
  </p>`;

  container.querySelector('button')?.addEventListener('click', (event) => {
    event.preventDefault();
    window.portalGateToForeground.emit('failed-highlights-message-clicked');
  });
};

export default () => {
  // To be safe...
  window.portalGateToForeground.off('add-failed-extension-or-youtube-highlights-message', add);
  window.portalGateToForeground.off('remove-failed-extension-or-youtube-highlights-message', remove);

  window.portalGateToForeground.on('add-failed-extension-or-youtube-highlights-message', add);
  window.portalGateToForeground.on('remove-failed-extension-or-youtube-highlights-message', remove);
};
